import ExpenseTypeDialog from './ExpenseTypeDialog';

export default ExpenseTypeDialog;
